import TabChartOverview from '@/views/App/Dashboard/Accountant/TabChartOverview.vue';
import TabInfo from '@/views/App/Dashboard/Accountant/TabInfo.vue';
import TabPotentialUnits from '@/views/App/Dashboard/Accountant/TabPotentialUnits.vue';

const routesDashboardAccountant= [
    {
        path: 'info',
        name: 'dashboardAccountantInfo',
        component: TabInfo
    },
    {
        path: 'chart-overview',
        name: 'dashboardAccountantChartOverview',
        component: TabChartOverview
    },
    {
        path: 'potential-units',
        name: 'dashboardAccountantPotentialUnits',
        component: TabPotentialUnits
    },
];

export default routesDashboardAccountant;